var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},_vm._l((_vm.orgList),function(item){return _c('div',{key:item.id,staticClass:"card",on:{"click":function($event){return _vm.toHome(item.id)}}},[_vm._v(" "+_vm._s(item.zhName)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }